/* eslint-disable @typescript-eslint/no-unused-vars */
import ProfileCard from "Components/Cards/ProfileCard";
import ContentContainer from "Components/Container/ContentContainer";
import {
  Description,
  MasterHeader,
  SubDescriptionLight,
  SubTitle,
  Title,
} from "Components/CustomComponents";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import Tabs from "Components/Tabs/Tabs";
import {
  DashboardRoutesCounts,
  Drivers,
  RouteWithStopsAndDriver,
} from "Data/interfaces";
import {
  useLazyGetDashboardRouteQuery,
  useLazyGetRoutesCountsQuery,
} from "Data/services/dashbaordApi";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { BoxIcon, GraphIcon, UsersIcon } from "svg";
import DashboardCard from "../../Components/Cards/DashboardCard";
import RouteDirection from "./components/RouteDirection";
import styles from "./styles/Dashboard.module.scss";

interface DashboardProps {
  setPage?: React.Dispatch<React.SetStateAction<string>>;
}

const Dashboard: React.FC<DashboardProps> = () => {
  const [routesCounts, setRoutesCounts] =
    useState<DashboardRoutesCounts | null>(null);
  const [selectedRoute, setSelectedRoute] = useState<string | null>(null);

  const [routes, setRoutes] = useState<RouteWithStopsAndDriver[]>();

  const [
    getRoutesCounts,
    { data: routesCountsResponse, isFetching: routesCountsLoading },
  ] = useLazyGetRoutesCountsQuery();
  const [
    getDashboardRoutes,
    { data: dashboardRoutes, isFetching: routesLoading },
  ] = useLazyGetDashboardRouteQuery();

  useEffect(() => {
    getRoutesCounts();
    getDashboardRoutes();
  }, []);

  useEffect(() => {
    if (routesCountsResponse) {
      setRoutesCounts(routesCountsResponse.data);
    }
  }, [routesCountsResponse]);

  useEffect(() => {
    if (dashboardRoutes) {
      setRoutes(dashboardRoutes.data);
    }
  }, [dashboardRoutes]);

  useEffect(() => {
    if (routes) {
      if (routes?.length > 0 && !selectedRoute) {
        setSelectedRoute(routes[0].route_name);
      }
    }
  }, [routes, selectedRoute]);

  return (
    <ContentContainer classes={styles.Dashboard}>
      <Container className={`${styles.container} mx-0`}>
        <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
          <Col className={`${styles.col} mt-2 mb-2`} lg={4} md={6} xs={12}>
            <DashboardCard
              icon={routesCountsLoading ? <Spinner size="sm" /> : <UsersIcon />}
              number={routesCounts?.active_routes as number}
              text={"Active Routes"}
              cardBg="#e4e4ff"
            />
          </Col>
          <Col className={`${styles.col} mt-2 mb-2`} lg={4} md={6} xs={12}>
            <DashboardCard
              icon={routesCountsLoading ? <Spinner size="sm" /> : <BoxIcon />}
              number={routesCounts?.total_stops_today as number}
              text={"Total Stops Today"}
              cardBg="#fef2d6"
            />
          </Col>
          <Col className={`${styles.col} mt-2 mb-2`} lg={4} md={6} xs={12}>
            <DashboardCard
              icon={routesCountsLoading ? <Spinner size="sm" /> : <GraphIcon />}
              number={routesCounts?.completed_stops as number}
              text={"Completed Stops"}
              cardBg="#d9f7e7"
            />
          </Col>
        </Row>
      </Container>
      <SubTitle text="Route Tracking" classes="mb-2" />
      {routesLoading && routes?.length === 0 && <CustomLoader />}
      {!routesLoading && routes?.length === 0 && <NoDataFound />}
      <div className={`${styles.routeContainer} mt-3 mb-4`}>
        {routes?.map((route, index) => {
          return (
            <ContentContainer
              key={index}
              bg="#F5F5F5"
              hasBoxShadow={false}
              classes={`${styles.route} p-4`}
            >
              <MasterHeader text={route.route_name} />
              <div className="d-flex flex-row gap-2 my-3">
                <ContentContainer
                  bg="#efefef"
                  hasBoxShadow={false}
                  classes="p-3"
                  style={{ borderRadius: "10px" }}
                >
                  <Title
                    text={route.total_stops as unknown as string}
                    classes="mb-1"
                  />
                  <SubDescriptionLight text="Total Stops" />
                </ContentContainer>
                <ContentContainer
                  bg="#efefef"
                  hasBoxShadow={false}
                  classes="p-3"
                  style={{ borderRadius: "10px" }}
                >
                  <Title
                    text={route.remaining_stops as unknown as string}
                    classes="mb-1"
                  />
                  <SubDescriptionLight text="Remaining Stops" />
                </ContentContainer>
              </div>
              <Description text="Current Driver" classes="mb-2" />
              {route?.drivers?.[0] && (
                <ProfileCard
                  driver={route.drivers[0] as unknown as Drivers}
                  routeId={route.id}
                />
              )}
            </ContentContainer>
          );
        })}
      </div>

      <Tabs
        classes="mb-3"
        // tabs={[
        //   { label: "Route 1", value: "route 1" },
        //   { label: "Route 2", value: "route 2" },
        //   { label: "Route 3", value: "route 3" },
        // ]}
        tabs={(routes || []).map((route) => ({
          label: route.route_name,
          value: route.route_name,
        }))}
        current={selectedRoute as string}
        onChange={(value) => setSelectedRoute(value)}
      />
      <Container className="mx-0">
        {selectedRoute &&
          (routes || [])
            .filter((route) => route.route_name === selectedRoute)
            .map((route) => (
              <div key={_.uniqueId("container_")}>
                <div className={styles.mapContainer}>
                  <RouteDirection id={route.id} />
         
                </div>
              </div>
            ))}
      </Container>
    </ContentContainer>
  );
};

export default Dashboard;
